import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

// Todo @devin" once the old service request is removed, we should make the reason mandatory
export async function skipCurrentTaskInServiceRequest(
  id: string,
  reason?: string
) {
  try {
    const res = await fetcher(
      `${API_BASE_PATH}/${id}/skip`,
      {
        method: 'POST',
        body: { reason },
      },
      undefined
    );

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
